var css_variables = ( function( $ ) {

	var _init = function() {
		var $header = $( '#header' );

		// Set CSS variables here
		$( 'html' ).get( 0 ).style.setProperty( '--header-height', $header.outerHeight( false ) + 'px' );

		$( window ).smartresize( function() {
			$( 'body' ).get( 0 ).style.setProperty( '--header-height', $header.outerHeight( false ) + 'px' );
		})
	};

	$( document ).ready( _init );

} )( jQuery );

module.exports = css_variables;